import { useQuery } from '@tanstack/react-query';
import { SalesMetrosService } from '../services';
import { salesMetrosKeys } from '../queryKeys';

/**
 * The zips one sales metro owns, for its Zip Codes dialog. The dialog mounts
 * only while open, so this reads exactly when an admin asks to see them.
 *
 * @param {string} salesMetroId
 */
export const useSalesMetroZips = (salesMetroId) => {
  const { data, isError, isPending } = useQuery({
    queryKey: salesMetrosKeys.zips(salesMetroId),
    queryFn: () => SalesMetrosService.getSalesMetroZips(salesMetroId),
    enabled: Boolean(salesMetroId),
    retry: false,
  });

  return {
    zips: data ?? [],
    isPending,
    isError,
  };
};
